import { HiCog6Tooth } from "react-icons/hi2";

export const SettingIcon = ({ width, height, color, ...props }) => (
  <HiCog6Tooth
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
